var _circle, _g, _path, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffda44",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#496e2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-.186.002-11.13 102.4-11.13 102.4h215.942c-46.705-62.177-121.06-102.4-204.812-102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c83.752 0 158.107-40.223 204.811-102.4h-409.622c46.704 62.177 121.059 102.4 204.811 102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.874 204.8h-262.004l11.13 102.4h250.874c3.36-16.543 5.126-33.665 5.126-51.2s-1.768-34.657-5.126-51.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 307.2c0-53.426 0-247.096 0-307.2-141.384 0-256 114.616-256 256 0 17.535 1.768 34.657 5.126 51.2z",
    fill: "#d80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m141.257 122.435 16.576 51.015h53.645l-43.397 31.533 16.574 51.017-43.398-31.53-43.398 31.53 16.577-51.017-43.397-31.533h53.643z",
    fill: "#f0f0f0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogo);
export default __webpack_public_path__ + "static/media/togo.d4f20212a286630042578ddc1548fe87.svg";
export { ForwardRef as ReactComponent };